(function(){
  function init(){
    var r=document.querySelector('[data-lbf-product]');if(!r)return;
    var f=r.querySelector('#lbf-cro-form'),s=r.querySelector('.lbf-cro__select'),p=r.querySelector('[data-price]'),a=r.querySelector('[data-atc]');
    var bar=r.querySelector('[data-sticky-atc-bar]'),sp=r.querySelector('[data-sticky-price]'),sa=r.querySelector('[data-sticky-atc]');
    var gp=r.querySelector('[data-gift-progress]');
    var cartTotal=gp?parseInt(gp.dataset.cartTotal||'0',10):0;
    var threshold=gp?parseInt(gp.dataset.threshold||'6998',10):6998;
    function euro(cents){return (Math.max(0,cents)/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'}
    function gift(o){
      if(!gp||!o)return;
      gp.textContent='🎁 Un seul cadeau par commande : Pack Découverte dès 69,98 € ou 2 parfums de 30 ml, parfum 50 ml dès 100 €, parfum 100 ml dès 150 €. Le cadeau du palier le plus élevé remplace le précédent.';
    }
    function sync(o){
      if(!o)return;
      if(p)p.textContent=o.dataset.price;
      if(sp)sp.textContent=o.dataset.price;
      if(a){a.disabled=o.disabled;a.textContent=o.disabled?'ÉPUISÉ':'AJOUTER AU PANIER'}
      if(sa){sa.disabled=o.disabled;sa.textContent=o.disabled?'ÉPUISÉ':'AJOUTER AU PANIER'}
      gift(o);
    }
    if(f&&s){
      var os=Array.from(s.options);
      f.addEventListener('change',function(){
        var vs=Array.from(f.querySelectorAll('input[type=radio]:checked')).map(function(x){return x.value});
        var o=os.find(function(x){try{return JSON.stringify(vs)===JSON.stringify(JSON.parse(x.dataset.options))}catch(e){return false}});
        if(o){s.value=o.value;sync(o)}
      });
      sync(s.options[s.selectedIndex]);
    }
    r.querySelectorAll('.lbf-cro__thumbs button').forEach(function(b){b.onclick=function(){var h=r.querySelector('.lbf-cro__hero');if(h){h.removeAttribute('srcset');h.src=b.dataset.src}}});
    if(bar&&sa&&f&&a){
      sa.addEventListener('click',function(){if(a.disabled)return;if(typeof f.requestSubmit==='function')f.requestSubmit(a);else a.click()});
      var show=function(v){bar.classList.toggle('is-visible',v);bar.setAttribute('aria-hidden',v?'false':'true')};
      if('IntersectionObserver' in window){new IntersectionObserver(function(es){show(!es[0].isIntersecting&&window.scrollY>150)},{threshold:.05}).observe(a)}
      else{window.addEventListener('scroll',function(){show(window.scrollY>450)},{passive:true})}
    }
    document.addEventListener('cart:updated',function(e){
      if(e.detail&&typeof (e.detail.cart||e.detail).total_price==='number'){cartTotal=(e.detail.cart||e.detail).total_price;if(s)gift(s.options[s.selectedIndex])}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();